import { apiClient } from "../../../lib/apiClient";
import type { ActivityPage } from "./types";

/**
 * Fetch one page of the project activity feed.
 *
 * @param projectId Project UUID (path param).
 * @param cursor Opaque cursor from a prior call; null/omit for the first page.
 * @param limit Page size, 1–50. Defaults to 10 on the server.
 */
export async function fetchActivity(
  projectId: string,
  cursor: string | null,
  limit = 10,
): Promise<ActivityPage> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  const r = await apiClient.get<ActivityPage>(
    `/api/admin/projects/${projectId}/activity?${params.toString()}`,
  );
  return r.data;
}
